import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
// import FAQ from '../../components/LandingPage/FAQ/FAQ';
import HowItWorks from '../../components/LandingPage/HowItWorks/HowItworks';
import BuyToken from '../../components/LandingPage/BuyToken/BuyToken';
import GetStarted from '../../components/LandingPage/GetStarted/GetStarted';
import Hero from '../../components/LandingPage/Hero/Hero';
import Callout from '../../components/LandingPage/Callout/Callout';
// import Testimonials from '../../components/LandingPage/Testimonials/Testimonials';
// import PopularNFTS from '../../components/LandingPage/PopularNFTS/PopularNFTS';
import MiniHowItWorks from '../../components/LandingPage/mini-HowItWorks/MiniHowItWorks';
import Footer from '../../components/LandingPage/Footer/Footer';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import ExploreTokensAccessibility from '../../components/LandingPage/ExploreTokensAccessibility/ExploreTokensAccessibility';
import { useSelector } from 'react-redux';

const LandingPage = () => {
  const { totalCount } = useSelector(state => state.cart);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []); // Runs on initial load

  return (
    <main className='flex flex-col gap-0 screen-500:gap-6 sm:gap-5 lg:gap-7'>
      {/* Navbar */}
      <Navbar 
        showCart={totalCount > 0} 
        showSeasonDropdown={false} 
        showLiveGame={true} 
      />
      {/* Hero Section */}
      <Hero />
      {/* Callout Section */}
      <Callout />
      {/* How It Works Section */}
      <HowItWorks/>
      {/* Get Started Section */}
      <GetStarted />
      {/* Popular NFT's */}
       {/* <PopularNFTS /> */}
      {/* Buy Token Section */}
      <BuyToken />
      {/* Testimonials Section */}
      {/* <Testimonials /> */}
      {/* FAQ Section */}
      {/* <FAQ /> */}
      {/* Mini How It Works Section */}
      <MiniHowItWorks />
      {/* Footer Section */}
      <Footer />

      {/* Explore Tokens-Fixed */}
      <ExploreTokensAccessibility />
    </main>
  )
}

export default LandingPage